<div class="container py-4">
  @if (isLoading() && !complainDetail()) {
  <div class="d-flex justify-content-center align-items-center my-5 py-5 text-secondary">
    <div class="spinner-border text-primary me-3" role="status"></div>
    <span>Loading discussion channels...</span>
  </div>
  } @else if (complainDetail()) {
  <div class="row g-4">

    <!-- LEFT COLUMN: Ticket Summary -->
    <div class="col-lg-4">
      <div class="card border-0 shadow-sm sticky-top" style="top: 24px;">
        <div class="card-header bg-light py-3 border-bottom d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-sm btn-light border d-flex align-items-center justify-content-center"
              style="width: 32px; height: 32px; border-radius: 6px;" (click)="navigateToList()"
              title="Back to Complaints List">
              <i class="fa fa-solid fa-arrow-left fs-7 text-secondary"></i>
            </button>
            <h5 class="card-title fw-bold mb-0 text-dark">Ticket Reference</h5>
          </div>
          <span class="badge bg-info text-dark rounded-pill px-3 py-2 text-uppercase">{{ complainDetail()?.status
            }}</span>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label class="text-uppercase tracking-wider fs-7 text-muted fw-bold d-block mb-1">Issue Subject</label>
            <h4 class="fw-bold text-dark h5">{{ complainDetail()?.title }}</h4>
          </div>
          <hr class="text-muted opacity-25">
          <div class="mb-3">
            <label class="text-uppercase tracking-wider fs-7 text-muted fw-bold d-block mb-1">Dealer LoginName</label>
            <div class="d-flex align-items-center gap-2">
              <div class="avatar-circle-sm bg-primary-subtle text-primary fw-bold text-uppercase">
                {{ complainDetail()?.dealerLoginName | slice:0:2 }}
              </div>
              <span class="fw-semibold text-secondary">{{ complainDetail()?.dealerLoginName }}</span>
            </div>
          </div>
          <hr class="text-muted opacity-25">
          <div class="mb-0">
            <label class="text-uppercase tracking-wider fs-7 text-muted fw-bold d-block mb-1">Initial Problem</label>
            <p class="text-secondary bg-light p-3 rounded border mb-0 lh-base fs-6">{{ complainDetail()?.description }}
            </p>
          </div>
          <hr class="text-muted opacity-25"><!-- BEAUTIFIED CLOSE TICKET BUTTON -->
          @if (complainDetail()?.status !== ComplainFormStatus.CLOSE && isClosingTicketBtnAccess()) {
          <div class="d-grid mt-3">
            <button type="button"
              class="btn btn-outline-danger d-flex align-items-center justify-content-center gap-2 py-2 fw-semibold shadow-sm hover-danger-filled"
              [disabled]="isClosingTicketLoading()" (click)="onCloseTicket()">

              <!-- Dynamic Loading Control Flow State Structure -->
              @if (isClosingTicketLoading()) {
              <div class="spinner-border spinner-border-sm text-danger" role="status"></div>
              <span>Processing Closure...</span>
              } @else {
              <i class="fa fa-solid fa-lock-open"></i>
              <span>Close Complaint Ticket</span>
              }

            </button>
          </div>

          } @else {
          <!-- Disabled state indicating the ticket is already locked -->
          <div class="d-grid mt-3">
            <button type="button"
              class="btn btn-light border d-flex align-items-center justify-content-center gap-2 py-2 text-muted"
              disabled>
              <i class="fa fa-solid fa-lock text-secondary"></i>
              <span>Ticket is {{ complainDetail()?.status }}</span>
            </button>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN: Chat Timeline -->
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm d-flex flex-column" style="height: calc(100vh - 140px); min-height: 520px;">

        <div class="card-header bg-white py-3 border-bottom d-flex align-items-center gap-3">
          <div class="avatar-circle bg-success text-white shadow-sm">
            <i class="fa fa-solid fa-comments"></i>
          </div>
          <div>
            <h5 class="fw-bold mb-0 text-dark">Resolution Correspondence Channel</h5>
            <small class="text-muted">Live message synchronization logs</small>
          </div>
        </div>

        <!-- Central Thread Scroll Window -->
        <div class="card-body flex-grow-1 overflow-y-auto bg-chat-pattern p-4" #chatScrollContainer>
          <div class="d-flex flex-column gap-4">
            @for (msg of complainDetail()?.chatHistoryList; track msg.id) {

            <div class="d-flex w-100"
              [ngClass]="msg.loginName === currentUser() ? 'justify-content-end' : 'justify-content-start'">

              <!-- Main Bubble Container Grid -->
              <div class="d-flex gap-2 chat-message-row"
                [ngClass]="msg.loginName === currentUser() ? 'flex-row-reverse' : 'flex-row'">

                <!-- BEAUTIFIED SENDER AVATAR (Hides for current user profile) -->
                @if (msg.loginName !== currentUser()) {
                <div class="avatar-circle-sm bg-purple text-white shadow-sm fw-bold text-uppercase flex-shrink-0 mt-3"
                  title="{{ msg.loginName }}">
                  {{ msg.loginName.substring(0, 2) }}
                </div>
                }

                <div class="message-wrapper"
                  [ngClass]="msg.loginName === currentUser() ? 'align-items-end' : 'align-items-start'">

                  <!-- Beautified Username Badge Header Row -->
                  @if (msg.loginName !== currentUser()) {
                  <div class="mb-1 d-flex align-items-center gap-2 ps-1">
                    <span class="fw-bold text-dark fs-7">{{ msg.loginName }}</span>
                    <span class="badge bg-light text-secondary border font-monospace px-1 py-0 fs-8">#{{ msg.id
                      }}</span>
                  </div>
                  }

                  <!-- Chat Message Bubble Container -->
                  <div class="message-bubble position-relative shadow-sm"
                    [ngClass]="msg.loginName === currentUser() ? 'bg-primary text-white rounded-out-right' : 'bg-white text-dark border rounded-out-left'">

                    <!-- Reply Citation Reference Row Layouts -->
                    @if (msg.messageType === 'REPLY') {
                    <div class="reply-quote mb-2 text-truncate opacity-75 p-1 px-2 border-start border-3"
                      [ngClass]="msg.loginName === currentUser() ? 'border-white text-white bg-white-10' : 'border-primary text-muted bg-light'">
                      <i class="fa fa-solid fa-reply me-1 fs-8"></i>
                      <span class="fst-italic">"{{ getOriginalMessageBody(msg.previousMessageId) }}"</span>
                    </div>
                    }

                    <p class="mb-0 text-start whitespace-pre-wrap fs-6">{{ msg.body }}</p>

                    <!-- HIDDEN HOVER ACTION LINK BUTTON FOR QUICK INTERACTION REPLIES -->
                    <div class="message-actions position-absolute top-50 translate-middle-y"
                      [ngClass]="msg.loginName === currentUser() ? 'start-0 translate-x-left' : 'end-0 translate-x-right'">
                      <button type="button"
                        class="btn btn-sm btn-white shadow-sm border rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style="width: 28px; height: 28px;" (click)="setReplyTarget(msg)" title="Reply to this message">
                        <i class="fa fa-solid fa-reply text-secondary fs-8"></i>
                      </button>
                    </div>

                  </div>

                  <!-- Clean, Single-Line Responsive Timestamp Alignment -->
                  <div class="mt-1.5 px-1 d-flex align-items-center gap-1.5 text-body-secondary"
                    [ngClass]="msg.loginName === currentUser() ? 'justify-content-end text-end' : 'justify-content-start text-start'"
                    style="font-size: 0.7rem; letter-spacing: 0.015em;">

                    <i class="fa fa-regular fa-clock opacity-60" style="font-size: 0.75rem;"></i>

                    <!-- Forces the date/time string to never wrap onto an ugly second line -->
                    <span class="fw-medium text-nowrap opacity-85">
                      {{ msg.sendDateTimeStr | convertMmt }}
                    </span>
                  </div>


                </div>

              </div>
            </div>

            }
          </div>
        </div>

        <!-- Bottom Action Input Box Form Panel -->
        <div class="card-footer bg-white border-top p-3 position-relative">

          <!-- DYNAMIC ANIMATED ANCHOR NOTIFICATION FOR REPLYING MODES -->
          @if (replyingToMessage()) {
          <div
            class="reply-tracker-bar d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom border-primary border-2 animate-slide-up">
            <div class="d-flex align-items-center gap-2 text-truncate">
              <i class="fa fa-solid fa-reply text-primary"></i>
              <span class="fs-7 text-secondary text-truncate">
                Replying to <strong>{{ replyingToMessage()?.loginName }}</strong>:
                <span class="fst-italic">"{{ replyingToMessage()?.body }}"</span>
              </span>
            </div>
            <button type="button" class="btn-close fs-8 ms-2" aria-label="Cancel reply"
              (click)="cancelReply()"></button>
          </div>
          }

          @if(complainDetail()?.status !== ComplainFormStatus.CLOSE) {
          <form (ngSubmit)="onSendMessage()" class="d-flex gap-2 mt-2">
            <input type="text" class="form-control py-2 border-2 bg-light focus-white"
              placeholder="Type your message reply here..." [ngModel]="chatInput()"
              (ngModelChange)="chatInput.set($event)" name="chatText" autocomplete="off" required>
            <button type="submit" class="btn btn-primary px-4 d-flex align-items-center gap-2"
              [disabled]="!chatInput().trim()">
              <span>Send</span>
              <i class="fa fa-solid fa-paper-plane"></i>
            </button>
          </form>
        }
        </div>

      </div>
    </div>

  </div>
  }
</div>
